var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingCommunityStreamlineTabler1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2812 17.0312V11.5625L7.375 7.65625L3.46875 11.5625V17.0312H7.375M11.2812 17.0312H7.375M11.2812 17.0312H17.5312V3.75C17.5312 3.5428 17.4489 3.34409 17.3024 3.19757C17.1559 3.05106 16.9572 2.96875 16.75 2.96875H8.9375C8.7303 2.96875 8.53159 3.05106 8.38507 3.19757C8.23856 3.34409 8.15625 3.5428 8.15625 3.75V8.4375M7.375 17.0312V13.9062",
    stroke: "#246B72",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2812 6.09375V6.10156",
    stroke: "#246B72",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4062 6.09375V6.10156",
    stroke: "#246B72",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4062 9.21875V9.22656",
    stroke: "#246B72",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4062 12.3438V12.3516",
    stroke: "#246B72",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingCommunityStreamlineTabler1);
export default __webpack_public_path__ + "static/media/Building-Community--Streamline-Tabler (1).93a723343005709fd3a3fd09e2f255d0.svg";
export { ForwardRef as ReactComponent };